import React from "react";
import { Menu, Dropdown } from "antd";
import LanguageIcon from "components/icons/LanguageIcon";
import Colors from "assets/Colors";
import { IntlContext } from "IntlProviderWrapper";
import World from "components/icons/World";
import { useTranslation } from "react-i18next";
import s from "./styles";

function applyItemStyle(selected) {
  return {
    height: "45px",
    background: selected && Colors.primary_web,
    color: selected && Colors.text_on_secondary,
    marginBottom: "10px",
    borderRadius: "2px",
  };
}

function LanguageSelector({ style, login }) {
  const { t } = useTranslation();
  const {
    switchToEnglish,
    switchToCatalan,
    switchToEuskera,
    switchToSpanish,
    locale,
  } = React.useContext(IntlContext);

  const menu = (
    <Menu
      style={{
        maxHeight: "225px",
        overflow: "auto",
        padding: "8px",
        paddingBottom: 0,
        minWidth: "147px",
      }}
    >
      <Menu.Item
        key="es"
        onClick={() => {
          switchToSpanish();
        }}
        style={applyItemStyle(locale === "es")}
      >
        {t("containers.SideBarTopMenuHOC.LanguageSelector.spanish")}
      </Menu.Item>
      <Menu.Item
        key="ca"
        onClick={() => {
          switchToCatalan();
        }}
        style={applyItemStyle(locale === "ca")}
      >
        {t("containers.SideBarTopMenuHOC.LanguageSelector.catalan")}
      </Menu.Item>
      <Menu.Item
        key="en"
        onClick={() => {
          switchToEnglish();
        }}
        style={applyItemStyle(locale === "en")}
      >
        {t("containers.SideBarTopMenuHOC.LanguageSelector.english")}
      </Menu.Item>
      <Menu.Item
        key="eu"
        onClick={() => {
          switchToEuskera();
        }}
        style={applyItemStyle(locale === "eu")}
      >
        {t("containers.SideBarTopMenuHOC.LanguageSelector.euskera")}
      </Menu.Item>
    </Menu>
  );

  return (
    <s.Wrapper style={style} onClick={(e) => e.stopPropagation()}>
      <Dropdown placement="bottomRight" overlay={menu} trigger={["click"]}>
        {login ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              gap: "10px",
              color: Colors.text_secondary,
            }}
          >
            <World />
            {locale === "es" ? (
              <s.text>
                {t("containers.SideBarTopMenuHOC.LanguageSelector.spanish")}
              </s.text>
            ) : locale === "ca" ? (
              <s.text>
                {t("containers.SideBarTopMenuHOC.LanguageSelector.catalan")}
              </s.text>
            ) : locale === "en" ? (
              <s.text>
                {t("containers.SideBarTopMenuHOC.LanguageSelector.english")}
              </s.text>
            ) : locale === "eu" ? (
              <s.text>
                {t("containers.SideBarTopMenuHOC.LanguageSelector.euskera")}
              </s.text>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div>
            <LanguageIcon />
          </div>
        )}
      </Dropdown>
    </s.Wrapper>
  );
}

export default LanguageSelector;
